import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-57d89550")
const _hoisted_1 = { class: "_main" }
const _hoisted_2 = { class: "_header" }
const _hoisted_3 = { class: "_headerBack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Settings ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "header" }, " Settings ", -1)
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "_setting" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "_setting_header" }, "Cookies", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" We use cookies to make this site work and to improve your experience. Note, with cookies disabled, core functionality of the site (deemed essential) may continue to place cookies in accordance with our cookie policy. To avoid cookies required for key functionality of the site, please do not use our service or application. ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("More information")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_12 = { class: "section" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "_setting" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_setting_header" }, "Policies")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Engaging in the use of gochase.me and its services carries implicit accordance with our terms, conditions and policies. Our terms, conditions, and policies can be found "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://gochase.me/policy" }, "here"),
  /*#__PURE__*/_createTextVNode(" - please follow the link to learn more. ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Terms of Service")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Cookie Policy")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Privacy Policy")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Progressive Web Application")
const _hoisted_19 = { class: "section" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "_setting" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_setting_header" }, "Report and help desk")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, " We take reports seriously. If you encountered something concerning, please issue it here. Please note however, deliberate misuse of the reporting system will be seen responded with a warning or possible account removal. ", -1)
const _hoisted_22 = {
  key: 0,
  class: "report"
}
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "dropdown" }
const _hoisted_25 = { class: "button" }
const _hoisted_26 = {
  key: 1,
  class: "reportOutcome"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Message sent")
], -1)
const _hoisted_28 = { class: "text" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" You must be signed in to use the report system. ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Sign in here")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "_footer _card" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Advisory"),
  /*#__PURE__*/_createElementVNode("p", null, " We are a small team that is dedicated to producing high quality experiences for our users. Please note, our team only speaks English. ")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TextArea = _resolveComponent("TextArea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconButton, {
          icon: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app'}))),
          white: true
        })
      ]),
      _hoisted_4
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_Checkbox, {
          toggled: _ctx.$store.state.Utils.cookies,
          label: "Cookies",
          onClick: _ctx.changeCookieSetting
        }, null, 8, ["toggled", "onClick"])
      ]),
      _createElementVNode("p", null, [
        _hoisted_9,
        _createVNode(_component_router_link, { to: "/policy/cookie" }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _hoisted_11
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _hoisted_14,
      _createElementVNode("p", null, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/policy/terms" }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/policy/cookie" }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/policy/privacy" }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/policy/pwa" }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      (!_ctx.$store.state.Auth.user.signedOut)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_21,
            (!_ctx.reportSendSuccess)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_Dropdown, {
                        white: true,
                        text: "Report type",
                        options: _ctx.reportType,
                        onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reportType.active=$event))
                      }, null, 8, ["options"])
                    ]),
                    _createVNode(_component_TextArea, {
                      default: _ctx.reportText,
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reportText = $event))
                    }, null, 8, ["default"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    (_ctx.sendingReport)
                      ? (_openBlock(), _createBlock(_component_IconButton, {
                          key: 0,
                          icon: "loader_spinner",
                          autoplay: true,
                          loop: true,
                          text: "Sending"
                        }))
                      : (_openBlock(), _createBlock(_component_IconButton, {
                          key: 1,
                          icon: _ctx.reportSendSuccess?'tick':_ctx.reportSendError?'cross':'',
                          autoplay: true,
                          text: "Send report",
                          onClick: _ctx.sendReport
                        }, null, 8, ["icon", "onClick"]))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("h4", null, " Sent by: " + _toDisplayString(_ctx.$store.state.Auth.user.name), 1),
                    _createElementVNode("p", null, " Report type: " + _toDisplayString(_ctx.reportType.options[_ctx.reportType.active].text), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.reportText), 1)
                  ])
                ]))
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_router_link, { to: "/account" }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            }),
            _hoisted_32
          ]))
    ]),
    _hoisted_33
  ]))
}